export const KING_MALAKOR_IMG =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_demon-kings-realm/artifacts/ik44yyu6_re%20lupo.jpg";

export const WOLF_SOLDIER_IMG =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_demon-kings-realm/artifacts/mj9jyutt_Soldato%20%28eroe%29.jpg";

export const DOGOLAND_LOGO = "/logo.png";

export const HERO_BANNER =
  "https://images.unsplash.com/photo-1773216344394-2ecfc535f31d?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85";

export const CASTLE_BG =
  "https://images.unsplash.com/photo-1779286661453-0fff222bccee?crop=entropy&cs=srgb&fm=jpg&w=1920&q=85";

export const DEMON_HELMET =
  "https://images.unsplash.com/photo-1576704563778-8fc304bd63c0?crop=entropy&cs=srgb&fm=jpg&w=800&q=85";

/* Mark — the human protagonist (player-provided portrait): full figure and a square face crop for dialogues */
export const MARK_IMG = "/mark.jpg";
export const MARK_FACE_IMG = "/mark_face.jpg";

/* Selka — the shamaness of the Blood Valley who helps Mark and the pack (player-provided portrait) */
export const SELKA_IMG = "/selka.jpg";
export const SELKA_FACE_IMG = "/selka_face.jpg";
export const BERN_FACE_IMG = "/bern_face.jpg";
